const faq = {
    init : () => {
        var items = helper.element(".js-faq", true);

        for (const item of items) {
            item.classList.remove("open");
            helper.event(item, "click touchstart", (e) => {
                //e.preventDefault();
                for (const item of items) {
                    item.classList.remove("open");
                }
                e.currentTarget.classList.add("open");
            });
        }
    }
};